// @ts-nocheck

/**
 * * `observer` - The Observer (12-24 months)
 * `combiner` - The Combiner (2-3 years)
 * `storyteller` - The Storyteller (3-4 years)
 * `explorer` - The Explorer (4-5+ years)
 */
export type LanguageLevelA01Enum =
  typeof LanguageLevelA01Enum[keyof typeof LanguageLevelA01Enum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LanguageLevelA01Enum = {
  observer: "observer",
  combiner: "combiner",
  storyteller: "storyteller",
  explorer: "explorer",
} as const;
